import React from "react";
import { Radio } from "antd";
import "./style.scss";

function RadioButton({
  options = [],
  value,
  onChange,
  variant = "secondary",
  className,
  outlined,
  ...rest
}) {
  return (
    <div
      className={`radio-button ${variant === "primary" ? "primary-radio" : "secondary-radio"} ${className ? className : ""} ${outlined ? "outline-radio" : ""}`}
    >
      <Radio.Group onChange={onChange} value={value} {...rest}>
        {options.map((item) => (
          <Radio key={item.value} value={item.value}>
            {item.label}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
}

export default RadioButton;
